import * as React from 'react';

import { setVars } from 'kiwifruit'
import { KiwifruitUser, styleFor } from 'kiwifruit-react'
import Sizer from './Sizer'


class SizedBox extends React.Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  render() {
    return <KiwifruitUser render={({ getVariable, addConstraint }) => {
      const { box, children } = this.props
      const { childrenSize } = this.state

      if (childrenSize) {
        addConstraint(...setVars(box, childrenSize))
      }

      return <div style={styleFor.div(getVariable, box)}>
        <Sizer owner={this} stateName="childrenSize">
          { children }
        </Sizer>
      </div>
    }} />
  }
}

export default SizedBox



// WEBPACK FOOTER //
// ./src/view/SizedBox.js